import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import Skeleton from "@mui/material/Skeleton";

import { Colors } from "@/theme";
import { getLocalisationVal } from "@/utils/localizationUtil";
import { isEmpty } from "lodash";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 16,
    borderBottomColor: Colors.TABLE_HEADER1,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: Colors.TABLE_HEADER2,
  },
}));

const TableRowComponent = ({ localization, loading, marginData }) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <TableBody>
        {Array.apply(null, Array(3))
          .map(function (y, i) {
            return i;
          })
          .map((id) => (
            <TableRow key={`skeleton-${id}`} sx={{ height: 80 }}>
              <StyledTableCell align="left">
                <Skeleton variant="rounded" width={"30%"} height={30} />
              </StyledTableCell>
              <StyledTableCell align="left">
                <Skeleton variant="rounded" width={"50%"} height={30} />
              </StyledTableCell>
              <StyledTableCell align="left">
                <Skeleton variant="rounded" width={"50%"} height={30} />
              </StyledTableCell>
              <StyledTableCell align="left">
                <Skeleton variant="rounded" width={"50%"} height={30} />
              </StyledTableCell>
            </TableRow>
          ))}
      </TableBody>
    );
  }

  return isEmpty(marginData) ? (
    <caption style={{ textAlign: "center", marginTop: 40 }}>
      {t("dashboard_screen.no_data")}
    </caption>
  ) : (
    <TableBody>
      {marginData
        ?.sort((a, b) => moment(b.time) - moment(a.time))
        ?.map((data, id) => (
          <StyledTableRow key={`item-${id}`} sx={{ height: 80 }}>
            <StyledTableCell align="left">
              {moment.utc(data.time).local().format("DD MMM YYYY HH:mm")}
            </StyledTableCell>
            <StyledTableCell align="left">
              {getLocalisationVal(localization, data.buy_price)}p
            </StyledTableCell>
            <StyledTableCell align="left">
              {getLocalisationVal(localization, data.sell_price)}p
            </StyledTableCell>
            <StyledTableCell align="left">
              {getLocalisationVal(localization, data.absolute_margin)}p
            </StyledTableCell>
          </StyledTableRow>
        ))}
    </TableBody>
  );
};

export default TableRowComponent;
